/*
 * @Description: 后台管理左侧导航
 * @Author: yy
 * @LastEditors: yangyang yyangacom@163.com
 * @Date: 2019-03-22 14:21:35
 * @LastEditTime: 2023-11-20 09:18:36
 */

import React, { Component } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

// @ts-ignore
import s from './adminBackNav.css';

import Link from '../../components/Link/Link';


class adminBackNav extends Component {
  constructor (props) {
    super(props);

    this.state = {
      current: '',
      list: [
        {
          url: '/adminAccount',
          name: '账号管理'
        },
        {
          url: '/new-cms',
          name: '品牌管理'
        },
        {
          url: '/new-cms/old',
          name: '品牌管理-old'
        },
        // {
        //   url: '/adminBrand',
        //   name: '品牌管理'
        // },
        {
          url: '/adminArticle',
          name: '文章管理'
        },
        {
          url: '/adminKOL',
          name: 'KOL管理'
        },
        // {
        //   url: '/adminReport',
        //   name: '报告自动化'
        // },
        {
          url: '/exportPDF/SetPage',
          name: '报告自动化(新)'
        },
        // {
        //   url: '/new-cms',
        //   name: '品牌管理-cms'
        // },
        {
          url: '/new-cms/report',
          name: '研究报告管理-cms'
        },
        {
          url: '/setRedisInfo',
          name: '已完成文章修改'
        // },
        // {
        //   url: '/new-cms/article',
        //   name: '文章管理-cms'
        }
      ]
    }
  }

  componentDidMount() {
    this.setState({
      // @ts-ignore
      current: global.location.pathname
    })
  }

  render() {
    const {list, current} = this.state;
    return (
      <ul className={s.container}>
        {
          list.map((item, index) => (
            <li className={current == item.url ? s.active : ''} key={index}>
              <Link to={item.url}>{item.name}</Link>
            </li>
          ))
        }
      </ul>
    )
  }
}

export default withStyles(s)(adminBackNav)



// WEBPACK FOOTER //
// src/routes/adminBackNav/adminBackNav.js